// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1wL9R","infoText":"styles_infoText__bOHlM","button":"styles_button__3FoMS"};